/**
 * Date を YYYY/MM/DD (Weekday) hh:mm にする
 * オプションで他の表記も作れると良いと思う (momentでやった方がいいかも)
 * @param Date
 *
 * @return String
 */
/* eslint-disable */
const displayDate = function (date) {
  const weekday = ['日', '月', '火', '水', '木', '金', '土']
  return (
    new Date(date).getMonth() +
    1 +
    '/' +
    new Date(date).getDate() +
    ' (' +
    weekday[new Date(date).getDay()] +
    ') ' +
    new Date(date).getHours() +
    ':' +
    ('00' + new Date(date).getMinutes()).slice(-2)
  )
}

export default displayDate



// WEBPACK FOOTER //
// ./src/functions/displayDate.js